"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerResource = void 0;
var vue_1 = require("vue");
var constants_1 = require("../../constants");
var Resources_1 = require("../../Resources");
var PreferencesManager_1 = require("../PreferencesManager");
exports.PlayerResource = vue_1.default.component('player-resource', {
    props: {
        type: {
            type: String,
        },
        canUseHeatAsMegaCredits: {
            type: Boolean || undefined,
        },
        count: {
            type: Number,
        },
        production: {
            type: Number,
        },
        plantsAreProtected: {
            type: Boolean || undefined,
        },
        steelValue: {
            type: Number,
        },
        titaniumValue: {
            type: Number,
        },
    },
    data: function () {
        return {};
    },
    methods: {
        mainCSS: function () {
            return 'resource_item--' + this.type;
        },
        iconCSS: function () {
            return 'resource_icon--' + this.type;
        },
        productionSign: function () {
            if (this.production > 0)
                return '+';
            return '';
        },
        displayPlantsProtectedIcon: function () {
            return this.type === Resources_1.Resources.PLANTS && this.plantsAreProtected;
        },
        showResourceValue: function () {
            var learnerModeOn = PreferencesManager_1.PreferencesManager.load('learner_mode') === '1';
            switch (this.type) {
                case Resources_1.Resources.STEEL:
                    return learnerModeOn || this.steelValue > constants_1.DEFAULT_STEEL_VALUE;
                case Resources_1.Resources.TITANIUM:
                    return learnerModeOn || this.titaniumValue > constants_1.DEFAULT_TITANIUM_VALUE;
                case Resources_1.Resources.HEAT:
                    return this.canUseHeatAsMegaCredits;
                default:
                    return false;
            }
        },
        getResourceValue: function () {
            if (this.type === Resources_1.Resources.STEEL) {
                return "" + this.steelValue;
            }
            else if (this.type === Resources_1.Resources.TITANIUM) {
                return "" + this.titaniumValue;
            }
            else if (this.type === Resources_1.Resources.HEAT && this.canUseHeatAsMegaCredits) {
                return '1';
            }
            else {
                return '';
            }
        },
    },
    template: "\n        <div class=\"resource_item\" :class=\"mainCSS()\">\n            <div class=\"resource_item_stock\">\n                <i class=\"resource_icon\" :class=\"iconCSS()\"></i>\n                <div class=\"resource_item_stock_count\">{{ count }}</div>\n            </div>\n            <div class=\"resource_item_prod\">\n                <span class=\"resource_item_prod_count\">{{ productionSign() }}{{ production }}</span>\n                <div v-if=\"displayPlantsProtectedIcon()\" class=\"shield_icon\"></div>\n                <div v-if=\"showResourceValue()\" class=\"resource_icon--metalbonus\">{{ getResourceValue() }}</div>\n            </div>\n        </div>\n    ",
});
//# sourceMappingURL=PlayerResource.js.map